import React from 'react'
import './index.css'
import isFullSizeCollectionUrlLocationUtil from 'utils/location/is-full-size-collection'

/**
 * @param count
 * @param isFullSize
 * @param isSample
 * @returns {JSX.Element|null}
 * @constructor
 */
const ProductSampledRecently = ({
  count,
  isFullSize,
  isSample
}) => {
  if (
    isFullSizeCollectionUrlLocationUtil() &&
    isSample !== true
  ) {
    return <></>
  }

  // isFullSize is only coming from Home screen products
  if (
    isFullSize ||
    !count
  ) {
    return <></>
  }

  const countStr = count.toLocaleString()

  return (
    <span className='product-sampled-count'>
      {`${countStr} sampled recently`}
    </span>
  )
}

export default ProductSampledRecently
